import React from 'react';
import { Box, Text } from 'core/components';

type LabelValueProps = {
  label: string;
  value: string | React.ReactNode;
  valueTextProps?: React.ComponentProps<typeof Text>;
};

const LabelValue = ({ label, value, valueTextProps, ...rest }: LabelValueProps) => (
  <Box mb={1} {...rest}>
    <Text fontWeight="bold">{label}</Text>: {value && <Text {...valueTextProps}>{value}</Text>}
  </Box>
);

LabelValue.defaultProps = {
  valueTextProps: {}
};

export default LabelValue;
